import { Grid, Typography } from '@mui/material';
import Flatpickr from 'react-flatpickr';
// import {
//     getReporteAgendamiento,
// } from '@/shared/actions/erp';

import {
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import {
  AlertSeverityEnum,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import DateRangePicker from '@/shared/components/ui/CustomSearch/DateRangePicker';
import { useRef, useState } from 'react';
import { useDownloadFile } from '@/shared';
import dayjs from 'dayjs';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}


export const SendByMotivoRechazoFromOT = {
  toPyl:"ENVIAR A RECOORDINAR",
  toVentas:"ENVIAR A GESTIÓN ASESOR"
}

const ModalGenerarExcelContratos: React.FC<ConfirmRejectOTDialogProps> = ({
  open,
  setOpen,
}) => {
  ///* global state
  const setAlert = useUiStore(s => s.setAlert);
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  const flatpickrRef = useRef<Flatpickr>(null);
  const [fechasReporte, setFechasReporte] = useState<Date[]>([]);

  const onGenerateExcel = async () => {
    setIsGlobalLoading(true)
    if(!fechasReporte[0] || !fechasReporte[1]){
        setAlert(
            true,
            'Escoja el rango de fechas',
            AlertSeverityEnum.error
        )
        setIsGlobalLoading(false)
        return
    }
    const data = {
        fecha_inicio:fechasReporte[0],
        fecha_fin:fechasReporte[1]
    }
    
    const {handleDownloadFile} = useDownloadFile()
    await handleDownloadFile({
      url:"api/v1/reporte-contrato/",
      method:"post",
      data:data,
      nameFile:`Reporte Contratos desde ${dayjs(data.fecha_inicio).format("LL")} hasta ${dayjs(data.fecha_fin).format("LL")} generado `,
      extensionFile:"xlsx"
    })

    setIsGlobalLoading(false)
  };

  return (
    <ScrollableDialogProps
      open={open}
      title="Generar Reporte de Contratos"
      cancelTextBtn="Cancelar"
      confirmTextBtn="Generar"
      confirmVariantBtn="outlined"
      // actions
      onClose={() => {
        setOpen(false);
      }}
      onConfirm={() => {
        onGenerateExcel()
      }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container spacing={3}>
            {/* -------- text -------- */}
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Seleccione la fecha de inicio y fecha fin del reporte a generar.
              </Typography>
            </Grid>

            {/* -------- Rango de fechas -------- */}
            <Grid item xs={12} >
                <TabTextLabel
                    text="Rango de Fechas"
                    pt="0"
                    pb="18px"
                    pl="0"
                    mt="0"
                />
                <DateRangePicker
                    flatpickrRef={flatpickrRef}
                    onChange={range => setFechasReporte(range)}
                />

            </Grid>

           
          </Grid>
        </>
      }
    />
  );
};

export default ModalGenerarExcelContratos;
